import { render, staticRenderFns } from "./BaseConfirmDelete.vue?vue&type=template&id=5276a681&"
import script from "./BaseConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports